/**
 * Formats a user's display name from name and surname, falling back to email
 * @param user - User object with name, surname, and email
 * @returns Formatted display name (e.g., "Jakub Vitek" or "user@example.com" if name/surname not available)
 */
export function formatDisplayName(user: {
  name?: string | null;
  surname?: string | null;
  email: string;
}): string {
  if (user.name && user.surname) {
    return `${user.name} ${user.surname}`;
  }
  return user.email;
}

